import { useExtendedWarrantyContext } from '@extendedWarranty/contexts/ExtendedWarrantyContext';
import { FormControl, TextField, Typography } from '@mui/material';

export const ManualUpload = () => {
    const {
        formik: { values, touched, errors, handleChange, handleBlur },
    } = useExtendedWarrantyContext();

    return (
        <div className="flex flex-col gap-10 h-fit flex-grow">
            <FormControl className="flex flex-col w-full gap-1">
                <Typography color="black" fontWeight={700} variant="body2">
                    Serial Numbers
                </Typography>
                <Typography fontSize={14}>Add each serial number separated by a comma or a new line.</Typography>
                <TextField
                    multiline
                    minRows={7}
                    id="serial_numbers"
                    name="serial_numbers"
                    placeholder="HQ111111111,HQ111111111,HQ111111111,HQ111111111"
                    value={values.serial_numbers}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.serial_numbers && Boolean(errors.serial_numbers)}
                    helperText={touched.serial_numbers && errors.serial_numbers}
                />
            </FormControl>
        </div>
    );
};
